import { Button, Grid, Paper, Stack, Typography } from '@mui/material'
import moment from 'moment'
import React, { useState } from 'react'
import AnDateTimePicker from '../../../../../components/DateTime/DateTimePicker'
import EPCRCard from '../../../../../components/Cards/EPCRCard'
import ECGType from './ECGType'
import Rhythm from './Rhythm'
import Structure from './Structure'
import Interval from './Interval'

const ECG = ({ submitModule }) => {
  const [moduleValues, setModuleValues] = useState({
    dateTime: moment(),
  })

  return (
    <Stack gap={2} padding={1}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} lg={6}>
          <Typography variant="title2">ECG</Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <AnDateTimePicker
            date={moduleValues.dateTime}
            fullWidth
            onChange={(newDate) =>
              setModuleValues((prev) => ({ ...prev, dateTime: newDate }))
            }
            size="small"
          />
        </Grid>
        <ECGType
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <Rhythm moduleValues={moduleValues} setModuleValues={setModuleValues} />
        <Structure moduleValues={moduleValues} setModuleValues={setModuleValues} />
        <Interval item='PR Interval' moduleValues={moduleValues} setModuleValues={setModuleValues} />
        <Interval item='QRS Interval' moduleValues={moduleValues} setModuleValues={setModuleValues} />
        <Interval item='QTc Interval' moduleValues={moduleValues} setModuleValues={setModuleValues} />
        <Interval item='QRS Axis' moduleValues={moduleValues} setModuleValues={setModuleValues} />
        <Grid item xs={12}>
          <Button
            onClick={() => submitModule('ECG', moduleValues)}
            variant="contained"
            color="success"
            fullWidth
          >
            Submit
          </Button>
        </Grid>
      </Grid>
    </Stack>
  )
}

export default ECG
